// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProductReport":"eo_a bht_a bht_x bht_j bht_u bht_bc bht_ql bht_vv"};